import { ChevronDown, Info } from 'lucide-react'
import { useState } from 'react'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { DetailGrid } from '@/components/play/DetailGrid'
import type { DetailRow } from '@/components/play/DetailRowItem'
import { cn } from '@/lib/utils'
import type { OriginalGame } from '@/types/original'

interface OriginalPlayDetailsProps {
	game: OriginalGame
}

export function OriginalPlayDetails({ game }: OriginalPlayDetailsProps) {
	const [isOpen, setIsOpen] = useState(true)

	const rows: DetailRow[] = [
		{ label: 'Game Type', value: game.type || '-' },
		{ label: 'Min Bet', value: game.min_bet || '-' },
		{ label: 'RTP', value: game.rtp ? `${game.rtp}%` : '-', highlight: Boolean(game.rtp) },
		{ label: 'Max Bet', value: game.max_bet || '-' },
	]

	return (
		<Collapsible open={isOpen} onOpenChange={setIsOpen} className='overflow-hidden rounded-2xl border border-border bg-card'>
			<CollapsibleTrigger className='flex w-full items-start justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-accent/40 sm:px-6 sm:py-5'>
				<div className='flex min-w-0 flex-col gap-2'>
					<div className='flex flex-wrap items-center gap-2'>
						<h1 className='text-xl font-semibold tracking-[-0.12px] text-foreground sm:text-2xl'>{game.game_name || '-'}</h1>
						{game.rtp ? (
							<span className='inline-flex items-center gap-1 rounded-md border border-primary-border bg-primary/10 px-2 py-0.5 text-xs font-semibold text-primary'>
								{`${game.rtp}% RTP`}
								<Info className='h-3.5 w-3.5 text-muted-foreground' aria-hidden />
							</span>
						) : null}
					</div>
					<p className='text-sm text-muted-foreground'>By BetsCycle Original</p>
				</div>
				<ChevronDown className={cn('mt-1 h-5 w-5 shrink-0 text-muted-foreground transition-transform', isOpen && 'rotate-180')} aria-hidden />
			</CollapsibleTrigger>

			<CollapsibleContent>
				<DetailGrid rows={rows} />
			</CollapsibleContent>
		</Collapsible>
	)
}
